module.exports = __webpack_public_path__ + "img/lang.c1b1fdee.svg";